<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MVN4l2/tc-custom/9781555846435.jpg?1728954778330" alt="This image is the cover for the book Geronimo Rex"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Geronimo Rex
      </h1>
      <p class="bookDescription body article font2">
        <b>Nominated for the National Book Award, </b><b>Barry Hannah’s brilliant debut offers “a fresh angle on the great American subject of growing up” (John Updike). </b><br/>  <br/> Roiling with love and torment, lunacy and desire, hilarity and tenderness, <i>Geronimo Rex</i> is the bildungsroman of an unlikely hero. Reared in gloomy Dream of Pines, Louisiana, whose pines have long since yielded to paper mills, Harry Monroe is ready to take on the world. Inspired by the great Geronimo’s heroic rampage through the Old West, Harry puts on knee boots and a scarf and voyages out into the swamp of adolescence in the South of the 1950s and ’60s. Along the way he is attacked by an unruly peacock; discovers women, rock ’n’ roll, and jazz; and stalks a pervert white supremacist who fancies himself the next Henry Miller in this “stunning piece of entertainment . . . vulgar, ribald, and wildly comic” (<i>The</i><i>New York Times</i>).<br/>  <br/> “Hannah writes about adolescence with a rare pizzazz and insight.” —<i>Rolling Stone</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Hannah
      </h2>
      
      <p class="authorDescription body article">Barry Hannah (1942-2010) was the author of twelve books: <I>Geronimo Rex</I>, <I>Airships</I>,<I> Ray</I>, <I>The Tennis Handsome</I>, <I>Nightwatchmen</I>, <I>Captain Maximus</I>, <I>Hey Jack</I>, <I>Boomerang</I>, <I>Never Die</I>, <I>Bats Out of Hell</I>, <I>High Lonesome</I> and <I>Yonder Stands Your Orphan</I>. His work was published in the<I> New Yorker</I>, <I>Esquire</I>, <I>Harper&#39;s</I>, the<I> Southern Review</I>, the<I> Oxford American</I>, <I>Gulf Coast Review</I>, and many other magazines. His achievements in fiction have been honored with an Academy Award in Literature by the American Academy of Arts &amp; Letters, and he was nominated for the American Book Award for <I>Ray</I> and the National Book Award for <I>Geronimo Rex</I>, which won the William Faulkner Prize. He has also received the Arnold Gingrich Short Fiction Award for <I>Airships</I>, and his body of work has been recognized with the PEN/Malamud Award for Short Fiction. Hannah was director of the MFA program at the University of Mississippi in Oxford for three decades, and also taught at the Iowa Writers&#39; Workshop, the Sewanee and Bennington summer writing seminars, and held teaching appointments at many other colleges and universities.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5bde64f0